import { useState, useEffect, useCallback } from "react";
import "./DocumentType.css";
import ArticleIcon from "@mui/icons-material/Article";
import TableMui from "../../../components/table/TableMui";
import ButtonCom from "../../../components/button/button";
import { AgGridReact } from "ag-grid-react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { Form } from "react-bootstrap";

// Icons -----------------------------------------
import { RiEdit2Line } from "react-icons/ri";
import { RiDeleteBinLine } from "react-icons/ri";
import { CgFileDocument } from "react-icons/cg";
import { FiPlus } from "react-icons/fi";
import { PiPencilSimpleLineBold } from "react-icons/pi";
// Components -----------------------------------------
import Widgets from "../../../components/Widgets";
import WidgetsIcon from "../../../components/Widgets/icon";
import WidgetsButton from "../../../components/Widgets/button";
import CircularProgress from "../../../components/CircularProgress";

import { useDispatch } from "react-redux";
import {
  commonGetData,
  commonSaveData,
  commonGetDataThird,
  initState,
} from "../../../redux/slices/commonSlice";
import { toast, ToastContainer } from "react-toastify";
import {
  getStaffDocumentListPath,
  getDocumentsListPath,
  AddEmployeeDocumentsPath,
  deleteEmployeeDocumentsPath,
  editEmployeeDocumentsPath
} from "../../../services/config";
import { HasPermission } from "../../../services/hasPermission";
import CustomPagination from "../../../components/CustomPagination";

const paginationPageSize = 10;

const DocumentType = ({ user, userDetails, commonState }) => {
  const dispatch = useDispatch();

  const [documentType, setDocumentType] = useState([]);
  const [staff_id, setStaff_id] = useState("");
  const [docId, setDocId] = useState("")
  const [isEdit, setIsEdit] = useState(false)
  const [isDelete, setIsDelete] = useState(false)
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [documentData, setDocumentData] = useState({
    userId: user.user_id,
    staffId: staff_id,
    doc_type: "",
    fileBase64: "",
  });
  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  useEffect(() => {
    setStaff_id(userDetails[0].staffId);
  }, [userDetails.length]);

  const [docList, setDocList] = useState([]);

  const getDocumentList = useCallback(() => {
    dispatch(
      commonGetDataThird(`${getStaffDocumentListPath}${userDetails[0].staffId}`)
    );
    dispatch(commonGetData(getDocumentsListPath));
  }, []);

  useEffect(() => {
    getDocumentList();
  }, []);

  useEffect(() => {
    if (commonState.commonGetSuccess) {
      setDocumentType(commonState.commonGetData);
      dispatch(initState());
    }
    if (commonState.commonGetThirdSuccess) {
      setDocList(commonState.commonGetThirdData);
      console.log(commonState.commonGetThirdData);
      dispatch(initState());
    }
  }, [commonState]);

  // Edit document
  const handleEditDocument = (data) => {
    // setDocId(data.id)
    // setOpen(true)
    console.log(data)
  }

  const editDocument = () => {
    document.getElementById("submit-btn").click();
  }

  // Delete document
  const handleDeleteDocument = (id) => {
    setDocId(id)
    setIsDelete(true)
  }

  const deleteDocument = () => {
    const formData = {
      path: deleteEmployeeDocumentsPath,
      data: {
        docId: docId,
        staffId: userDetails[0].staffId
      }
    }
    dispatch(commonSaveData(formData))
  }

  const canceleDeleteDocument = () => {
    setDocId("")
    setIsDelete(false)
  }

  const heading = [
    { headerName: "Document Name", 
      field: "file_name", 
      pinned: "left", 
      autoHeight: true,
      width: "300px",
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell", 
    },
    { headerName: "Type", field: "doc_type" },
    {
      headerName: "Uploaded On",
      cellRenderer: (rowData) => {
        return (
          <span>{rowData.data.uploadedOn ? rowData.data.uploadedOn : "-"}</span>
        );
      },
    },
    {
      headerName: "Expiry Date",
      cellRenderer: (rowData) => {
        return (
          <span>{rowData.data.expiryDate ? rowData.data.expiryDate : "-"}</span>
        );
      },
    },

    {
      headerName: "Status",
      cellRenderer: (rowData) => {
        return (
          <span>{rowData.data.status == "1" ? "Active" : "InActive"}</span>
        );
      },
    },

    {
      headerName: "Verified By",
      cellRenderer: (rowData) => {
        return (
          <span>{rowData.data.verifiedBy ? rowData.data.verifiedBy : "-"}</span>
        );
      },
    },

    {
      headerName: "Download",
      cellRenderer: (rowData) => {
        return <span>{rowData.data.file ? rowData.data.file : "-"}</span>;
      },
    },

    {
      headerName: "Action",
      cellRenderer: (rowData) => {
        return (
          <div>
            <PiPencilSimpleLineBold
              style={{
                cursor: "pointer",
                fontSize: 30,
                marginRight: "10px",
              }}
              className="edit-icon"
              onClick={() => {
                handleEditDocument(rowData.data);
              }}
            />
            <RiDeleteBinLine className="delete-icon"
              style={{ cursor: "pointer", fontSize: 30, color: "red" }}
              onClick={() => handleDeleteDocument(rowData.data.id)}
            />
          </div>
        );
      },
      pinned: "right", 
    },
  ];

  const handleClose = () => {
    setValidated(false);
    setOpen(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const fileHandle = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = function (event) {
      const base64 = event.target.result;
      setDocumentData({
        ...documentData,
        fileBase64: base64,
      });
    };
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDocumentData({
      ...documentData,
      [name]: value,
    });
  };

  const preSubmit = () => {
    document.getElementById("submit-btn").click();
  };

  const handleSubmit = (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();
    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      let d = {
        path: isEdit ? editEmployeeDocumentsPath : AddEmployeeDocumentsPath,
        data: {
          docId: docId,
          userId: user.user_id,
          staffId: userDetails[0].staffId,
          doc_type: documentData.doc_type,
          fileBase64: documentData.fileBase64,
        },
      };
      dispatch(commonSaveData(d));
    }
  };

  useEffect(() => {
    if (commonState.commonSuccess) {
      toast.success(commonState.commonMessage);
      handleClose();
      dispatch(initState());
      getDocumentList();
      setIsDelete(false)
      setIsEdit(false)
      setDocId("")
    }
    if (commonState.commonError) {
      toast.error(commonState.commonMessage);
      handleClose();
      dispatch(initState());
      setIsDelete(false)
      setIsEdit(false)
      setDocId("")
    }
  }, [commonState]);

  return (
    <div style={{ padding: "0 10px" }}>
      <Widgets
        icon={<WidgetsIcon icon={<CgFileDocument />} title="Documents" />}
        button={
          HasPermission("Documents", "create") && (
            <WidgetsButton
              type="button"
              text="Add Document"
              icon={<FiPlus className="btn-icon" />}
              onClick={handleClickOpen}
            />
          )
        }
        body={
          <>
          <div
            className="ag-theme-quartz custom-grid mt-3"
            style={{ height: "calc(100vh - 245px)", width: "100%" }}
          >
            <AgGridReact
              rowData={Array.isArray(docList) ? docList : []}
              columnDefs={heading}
              pagination={true}
              paginationPageSize={paginationPageSize}
              onGridReady={onGridReady}
            />
          </div>
          {
            docList && docList.length > 10 ? <div className="d-flex align-items-center justify-content-between custom-pagination">
              {gridApi && <CustomPagination gridApi={gridApi} />}
            </div> : null
          }
           
          </>
        }
      />

      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        onClose={handleClose}
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={() => setOpen(false)}>
              X
            </span>
            <span className="title">Documents</span>
          </div>
          <button className="universal-btn" onClick={preSubmit}>
            Upload Document
          </button>
        </DialogTitle>

        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <DialogContent>
            <Form.Group>
              <Form.Label className="color-gray">Document Type</Form.Label>
              <Form.Select
                name="doc_type"
                value={documentData.doc_type}
                onChange={handleChange}
                aria-label="Default select example"
                required
                className="universal-input"
              >
                <option value={""}>Select document type</option>
                {documentType?.map((row, idx) => {
                  return (
                    <option value={row.docId} key={idx}>
                      {row.doc_name}
                    </option>
                  );
                })}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                Please select a valid document type.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formFile" className="mt-3">
              <Form.Label className="color-gray">Select Document</Form.Label>
              <Form.Control
                type="file"
                name="fileBase64"
                onChange={fileHandle}
                required
                className="universal-input"
              />
              <Form.Control.Feedback type="invalid">
                Please select a valid file.
              </Form.Control.Feedback>
            </Form.Group>
          </DialogContent>

          <Button
            variant="contained"
            color="info"
            type="submit"
            id="submit-btn"
            style={{
              display: "none",
            }}
          >
            Save
          </Button>
        </Form>
      </Dialog>

      {/* Delete popup */}
      <Dialog
        fullWidth={true}
        maxWidth={"xs"}
        open={isDelete}
        onClose={canceleDeleteDocument}
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={canceleDeleteDocument}>
              X
            </span>
            <span className="title">Delete Document</span>
          </div>
        </DialogTitle>
        <DialogContent>
            <div className="mt-3">
              <h4><center className="color-white">Are you sure to delete this records!</center></h4>
              <div className="d-flex align-items-center justify-content-center gap-3 mt-2">
                <button className="universal-btn" style={{ width: "100px", height: "30px" }} onClick={deleteDocument}>Delete</button>
                <button className="secondary-btn" style={{ width: "100px", height: "30px" }} onClick={canceleDeleteDocument}>Cancel</button>
              </div>
            </div>
        </DialogContent>
      </Dialog>

      {/* <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      /> */}
    </div>
  );
};

export default DocumentType;
